export default {"src":"/_next/static/media/mercedes-benz-data-dashboard-logo-zweizeilig.ae231aa8.svg","height":53,"width":301,"blurWidth":0,"blurHeight":0};